@if (publicFiles().length === 0) {
  <p class="text-muted mb-0">No public photos yet. Use <mat-icon class="pio-inline-icon">public_off</mat-icon> on a photo of the pool to add it to the public listing.</p>
} @else {
  <div class="pio-list" cdkDropList cdkDropListOrientation="mixed" [cdkDropListData]="publicFiles()" [cdkDropListDisabled]="!editMode()" (cdkDropListDropped)="onDropped($event)">
    <!-- by id: the caller may build new objects for the same photos (e.g. when their thumbnails load) -->
    @for (file of publicFiles(); track file.id ?? file; let i = $index) {
      <!-- long press to drag on touch screens, so swiping still scrolls -->
      <div class="pio-item" cdkDrag [cdkDragDisabled]="!editMode()" [cdkDragStartDelay]="{ touch: 500, mouse: 0 }">
        @if (file.preview) {
          <app-listing-image class="pio-image" [src]="$any(file.preview)" [frame]="file.frame" [fit]="file.fit"></app-listing-image>
        }
        <span class="pio-badge" [class.pio-main]="i === 0">{{ i === 0 ? 'Main image' : i + 1 }}</span>
        @if (editMode()) {
          <button type="button" class="pio-remove" (click)="onRemove(file)" matTooltip="Remove from the public listing (stays in the pool)">
            <mat-icon>close</mat-icon>
          </button>
        }
        <img *cdkDragPreview class="pio-drag-preview" [src]="file.preview" alt="">
      </div>
    }
  </div>
}
